import { useContextState } from "../../../../../../hooks/theme"
import { assignColor } from "../../../../../../utils/methods/assignColor"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: '5px 30px 10px 30px',
            width: '100%',
            color: colors.color13,
            alignItems: 'center',
        },
        right: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        title: {
            fontWeight: '700',
            color: colors.color4,
        },
        porcentaje: ({ porcentaje }: { porcentaje: number }) => {
            return {
                color: assignColor(porcentaje),
                fontSize: '23px',
                fontWeight: '700',
                marginRight: '15px',
                lineHeight: '1',
            }
        },
        completado: {
            fontSize: '23px',
            lineHeight: '1',
        },
        accordion: {
            mx: '2px',
            borderRadius: '4px !important',
            boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px',
            mb: 2,
            '&.Mui-expanded': {
                mx: '2px',
            }
        },

        borderB: {
            width: '100%',
            height: '1px',
            left: '0px',
            bottom: '0px',
            position: 'absolute',
            borderBottom: `2px solid ${colors.color4}`,
            mb: 1,
        },
    }
}

export { useStyles }